import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../actions/search';
import {withRouter} from 'react-router';
import {deleteFile} from '../../actions/file'
import lodash  from 'lodash';
import moment from 'moment';
class Files extends Component {

	constructor(props,context) {
        super(props,context);
        this.deleteFile = this.deleteFile.bind(this);
        this.columns = [{
              Header: 'Bestandsnaam',
              accessor: 'filename',
              Cell: props => <span><a target="_blank" href={props.row._original.source} style={{display : 'inline'}} className="nav-link">{props.value}</a></span>
        },{
              Header: 'Bestandstype',
              accessor: 'file_type_name',
        },{
              Header: 'Valt onder product',
              accessor: 'product_name',
        },{
              Header: 'Upload datum',
              accessor: 'upload_date',
			  sortMethod: (a, b) => {
				  a = parseInt(moment(a, 'DD-MM-YYYY HH:mm:ss').toDate().getTime());
				  b = parseInt(moment(b, 'DD-MM-YYYY HH:mm:ss').toDate().getTime())
				  if (a === b) {
					return a > b ? 1 : -1;
				  }
				  return a > b ? 1 : -1;
				}
        },{
              Header: 'Geupload door',
              accessor: 'uploaded_by_name',
        },{
                Header: 'Is verstuurd naar klant?',
                accessor: 'is_been_notified',
                Cell: props => <span>{props.value == '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },{
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/files/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        },{
            Header: '#',
            accessor: 'id',
            Cell: props => <span><a onClick={(e, file, value) => this.deleteFile(e, props.row._original.id, props.row._original.is_deleted)} href="#" style={{display : 'inline'}} className="nav-link">{props.row._original.is_deleted == '1' ? 'Herstellen' : 'Verwijderen'}</a></span>
        }]

    }

    deleteFile(e, file, value, index) {

        const dp_address_id = this.props.dp_address_id;
        e.preventDefault();
        // -- find fileindex and adress index to update firebase
        const fileIndex = lodash.findIndex(this.props.fileData.files, function(value) { return value.id === file; });
        // -- get address index to update firebase
        const addressIndex = lodash.findIndex(this.props.clientData.allAddresses, function(value) { return value.dp_address_id === dp_address_id });
        const addressFileIndex = lodash.findIndex(this.props.clientData.allAddresses[addressIndex].files, function(value) { return value.id === file; });

        this.props.deleteFile(
            this.props.clientPath.clientPath,
            file,            
            value == 1 ? 0 : 1,
            addressIndex,
            fileIndex,
            addressFileIndex
        );

        setTimeout(function() { window.location.reload() }.bind(this), 2000);

    }

	componentWillMount() {
        // -- only files that are not deleted
    	this.props.updateSearchData(lodash.filter(this.props.files, {is_deleted: 0}))
    }

    componentDidUpdate(prevProps) {
        if(prevProps.files != this.props.files) {
            this.props.updateSearchData(lodash.filter(this.props.files, {is_deleted: 0}))
        }
    }




	render() {
        const filterValues = {
            showDeleted : {
                name: 'Is verwijderd',
                type: 'checkbox',
                key: 'is_deleted',
                value : '1'
            },
            showNotDeleted : {
                name: 'Is niet verwijderd',
                type: 'checkbox',
                key: 'is_deleted',
                value : '0'
            }
        }
        return (

            <div className="animated fadeIn">
                <Card>
                <CardHeader><Search filters={filterValues} ignoreSearchScope={true} data={this.props.files} keys_to_filter={['filename','file_type_name', 'product_name', 'upload_date', 'metaDataValues']}/></CardHeader>
                    <CardBody>
                        <CardTitle><i className="fa fa-align-justify"></i> Bestanden overzicht</CardTitle>
                        <DataTable defaultSorted={[{id: "upload_date",desc: true}]} additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.files} columns={this.columns} />
                    </CardBody>
                </Card>

            </div>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer ,
        clientPath: state.clientPathReducer ,
        fileData: state.FileReducer.files,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        deleteFile:(clientPath, fileId, value, addressIndex, fileIndex, addressFileIndex) => dispatch(deleteFile(clientPath, fileId, value, addressIndex, fileIndex, addressFileIndex))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Files))



// WEBPACK FOOTER //
// ./src/views/Addresses/files.js